const SESSION_EXPIRED_MESSAGE =
  "Your session has expired. Your page will be refreshed for reauthentication.";

let authHandlers;
let renewalPromise;
let interactiveSigninStarted = false;

export const registerAuthRecoveryHandlers = (handlers) => {
  authHandlers = handlers;
  renewalPromise = undefined;
  interactiveSigninStarted = false;

  return () => {
    if (authHandlers === handlers) {
      authHandlers = undefined;
      renewalPromise = undefined;
      interactiveSigninStarted = false;
    }
  };
};

export const beginInteractiveSignin = () => {
  if (interactiveSigninStarted || !authHandlers) {
    return;
  }

  interactiveSigninStarted = true;
  window.alert(SESSION_EXPIRED_MESSAGE);
  authHandlers.clearSession();
  authHandlers.signinRedirect();
};

export const recoverSession = () => {
  if (interactiveSigninStarted || !authHandlers) {
    return Promise.resolve(false);
  }

  if (!renewalPromise) {
    renewalPromise = (async () => {
      try {
        const user = await authHandlers.renewSession();
        if (!user?.access_token) {
          throw new Error("Silent renewal did not return an access token");
        }
        return true;
      } catch (error) {
        console.log("silent renew error", error?.message ?? error);
        beginInteractiveSignin();
        return false;
      } finally {
        renewalPromise = undefined;
      }
    })();
  }

  return renewalPromise;
};
